module.exports = __webpack_public_path__ + "img/spinner.48184387.svg";